  function onAnalyticsConsentChange({ analytics, functional, marketing, preferences }) {
    if (marketing && analytics) {
      // Re-attach fbq listeners for Target LP pages
      if (location.href.includes('/pages/target')) {

        document
          .querySelectorAll('#MainContent .shopify-section:first-child .banner__box')
          .forEach(el => {
            el.addEventListener('click', function(e) {
              fbq('track', 'CompleteRegistration');
            })
          })

        document
          .querySelectorAll('#MainContent .shopify-section:nth-child(3) a.button')
          .forEach(el => {
            el.addEventListener('click', function(e) {
              fbq('track', 'CompleteRegistration');
            })
          })

        setTimeout(function(){
          document
            .querySelectorAll('#MainContent .shopify-section:nth-child(6) #submit-search')
            .forEach(el => {
              el.addEventListener('click', function(e) {
                fbq('track', 'FindLocation');
              })
            })
        }, 3000)

        setTimeout(function(){
          document
            .querySelectorAll('#MainContent .klaviyo-form-Vg7WpZ button')
            .forEach(el => {
              el.addEventListener('click', function(e) {
                fbq('track', 'Subscribe');
              })
            })
        }, 3000)

        document
          .querySelectorAll('#MainContent .shopify-section:nth-child(9) .button')
          .forEach(el => {
            el.addEventListener('click', function(e) {
              fbq('track', 'AddToCart');
            })
          })

        document
          .querySelectorAll('#MainContent .shopify-section:nth-child(9) .button + div > a')
          .forEach(el => {
            el.addEventListener('click', function(e) {
              fbq('track', 'AddToWishlist');
            })
          })
      }

      // Global target CTA
      document
        .querySelectorAll('#target-cta')
        .forEach(el => {
          el.addEventListener('click', function(e) {
            fbq('track', 'CompleteRegistration');
          })
        })
    }
  }

  function onAcceptSelected({ analytics, functional, marketing, preferences }) {
    console.debug('[Enzuzo API]: callbacks.onAcceptSelected', { analytics, functional, marketing, preferences })
    onAnalyticsConsentChange({ analytics, functional, marketing, preferences })
  }

  function onAcceptAll({ analytics, functional, marketing, preferences }) {
    console.debug('[Enzuzo API]: callbacks.onAcceptAll', { analytics, functional, marketing, preferences })
    onAnalyticsConsentChange({ analytics, functional, marketing, preferences })
  }

  function onDecline({ analytics, functional, marketing, preferences }) {
    console.debug('[Enzuzo API]: callbacks.onDecline', { analytics, functional, marketing, preferences })
    onAnalyticsConsentChange({ analytics, functional, marketing, preferences })
  }

  function onInit({ analytics, functional, marketing, preferences }) {
    console.debug('[Enzuzo API]: callbacks.onInit', { analytics, functional, marketing, preferences })
    onAnalyticsConsentChange({ analytics, functional, marketing, preferences })
  }

  window.__enzuzoConfig = {
    callbacks: {
      acceptSelected: onAcceptSelected,
      acceptAll: onAcceptAll,
      decline: onDecline,
      init: onInit
    }
  }



window.dataLayer = window.dataLayer || [];

// user clicks top navigation to extend mega nav
try {
  
  document
    .querySelectorAll('header-menu > details > summary')
    .forEach(el => {
      el.addEventListener('click', function(){
        
        let click_text = el.textContent.trim()
        
        let event_data = {
          'event': 'interaction_event',
          'event_name': 'navigation',
          'event_action': 'mega_click',
          'event_category': click_text,
          'click_text': click_text,
          'location': 'header_menu'
        }
        
        console.log("Recording event...", event_data)
        window.dataLayer.push(event_data);

      })
    })
  
} catch(e) {}


// user clicks mega menu to then click on a link that navigates to a new page from header navigation
try {
  
  document
    .querySelectorAll('.mega-menu__list .list-menu__item')
    .forEach(el => {
      el.addEventListener('click', function(){
        
        let mega_menu_category = el.closest('header-menu').querySelector('& > details > summary').textContent.trim()
        let click_text = el.textContent.trim()
        let link_url = el.getAttribute('href')
        
        let event_data = {
          'event': 'interaction_event',
          'event_name': 'navigation',
          'event_action': 'link_click',
          'event_category': mega_menu_category,
          'event_label': click_text,
          'click_text': click_text,
          'link_url': link_url,
          'location': 'header_menu'
        }
        
        console.log("Recording event...", event_data)

        window.dataLayer.push(event_data);

      })
    })
  
} catch(e) {}


// user clicks a link to navigate to a new page directly from header navigation
try {
    
  document
    .querySelectorAll('.header__inline-menu > ul > li > a.list-menu__item')
    .forEach(el => {
      el.addEventListener('click', function(){
        
        let click_text = el.textContent.trim()
        let link_url = el.getAttribute('href')

        let event_data = {
          'event': 'interaction_event',
          'event_name': 'navigation',
          'event_action': 'link_click',
          'event_category': click_text,
          'click_text': click_text,
          'link_url': link_url,
          'location': 'header_menu'
        }
        
        console.log("Recording event...", event_data)
        window.dataLayer.push(event_data);

      })
    })
  
} catch(e) {}



// user clicks drawer category to expand mega navigation
try {
  
  document
    .querySelectorAll('.menu-drawer__menu-item')
    .forEach(el => {
      el.addEventListener('click', function(){
        
        const nextSibling = el.nextElementSibling;
        if (! nextSibling || !nextSibling.classList.contains('active')) {
          return false;
        }
        
        let click_text = el.textContent.trim()
        
        let event_data = {
          'event': 'interaction_event',
          'event_name': 'navigation',
          'event_action': 'mega_click',
          'event_category': click_text,
          'click_text': click_text,
          'location': 'drawer_menu'
        }
        
        console.log("Recording event...", event_data)

        window.dataLayer.push(event_data);

      })
    })
  
} catch(e) {}




// user clicks mega menu to then click on a link that navigates to a new page from drawer navigation
try {
  
  document
    .querySelectorAll('.menu-drawer__menu.has-submenu .submenu .list-menu__item')
    .forEach(el => {
      el.addEventListener('click', function(){

        let mega_menu_category = el.closest('.expandable').previousElementSibling.textContent.trim()        
        let click_text = el.textContent.trim()
        let link_url = el.getAttribute('href')
        let event_data = {
          'event': 'interaction_event',
          'event_name': 'navigation',
          'event_action': 'link_click',
          'event_category': mega_menu_category,
          'event_label': click_text,
          'click_text': click_text,
          'link_url': link_url,
          'location': 'drawer_menu'
        }
        
        console.log("Recording event...", event_data)
        window.dataLayer.push(event_data);

      })
    })
  
} catch(e) {}


// user clicks a link to navigate to a new page directly from drawer navigation
try {
  
  document
    .querySelectorAll('.menu-drawer__menu-item')
    .forEach(el => {
      el.addEventListener('click', function(){
        
        const nextSibling = el.nextElementSibling;
        if (nextSibling && nextSibling.classList.contains('expandable')) {
          return false;
        }
        
        let click_text = el.textContent.trim()
        let link_url = el.getAttribute('href')
        let event_data = {
          'event': 'interaction_event',
          'event_name': 'navigation',
          'event_action': 'mega_click',
          'event_category': click_text,
          'click_text': click_text,
          'link_url': link_url,
          'location': 'drawer_menu'
        }
        
        console.log("Recording event...", event_data)
        window.dataLayer.push(event_data);

      })
    })
  
} catch(e) {}



// user clicks a tile on the homepage that links to a new page (the tiles refers to the color tiles pregnancy, postpartum, etc. above the fold on the homepage)
try {
  
  document
    .querySelector('#shopify-section-template--14994861588577__dd3b716a-d1d0-41a7-9418-86f9a11bdbdb')
    .querySelectorAll('a.link')
    .forEach(el => {
      el.addEventListener('click', function(e){
        function capitalize (text) {
          return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
        }
        
        let click_text = capitalize(el.textContent.toLowerCase().replace('enter', '').trim())
        let link_url = el.getAttribute('href')
        
        let event_data = {
          'event': 'interaction_event',
          'event_name': 'navigation',
          'event_action': 'link_click',
          'event_category': click_text,
          'click_text': click_text,
          'link_url': link_url,
          'location': 'tile_menu'
        }
        
        console.log("Recording event...", event_data)
        window.dataLayer.push(event_data);
        
        let secondary_event_data = {
          'event': 'interaction_event',
          'event_name': 'blog_engagement',
          'event_action': 'link_click_to_blog',
          'event_label': click_text,
          'click_text': click_text,
          'link_url': link_url
         }
        
         console.log("Recording secondary event...", secondary_event_data)
        window.dataLayer.push(secondary_event_data);
        
      })
    })
  
} catch(e) {}



// user clicks one of the collection buttons on a collection page to toggle to a new collection
try {
  
  document
    .querySelector('.collection-meta-nav')
    .querySelectorAll('a.list-menu__item')
    .forEach(el => {
      el.addEventListener('click', function(e){

        let click_text = el.textContent.trim()
        let link_url = el.getAttribute('href')
        
        window.dataLayer.push({
          'event': 'interaction_event',
          'event_name': 'navigation',
          'event_action': 'link_click',
          'event_category': click_text,
          'click_text': click_text,
          'link_url': link_url,
          'location': 'collections_menu'
        });

      })
    })
  
} catch(e) {}



// user clicks on announcement bar
try {
  
  document
    .querySelector('.announcement-bar-slider')
    .querySelectorAll('a.announcement-bar__link')
    .forEach(el => {
      el.addEventListener('click', function(e){

        let click_text = el.textContent.trim()
        let link_url = el.getAttribute('href')

        window.dataLayer.push({
          'event': 'interaction_event',
          'event_name': 'navigation',
          'event_action': 'link_click',
          'event_category': click_text,
          'click_text': click_text,
          'link_url': link_url,
          'location': 'announcement_bar'
         });

      })
    })
  
} catch(e) {}


// track klaviyo form
window.addEventListener("klaviyoForms", function(e) { 
  
  if (e.detail.formId === 'TSCLTx') {
    // user clicks into a form field to begin filling out the form
    if (e.detail.type === 'open') {
      window.dataLayer.push({
        'event': 'interaction_event',
        'event_name': 'pop_up_engagement',
        'event_action': 'start_form',
        'location': 'welcome'
      });
    }
    
    // user closes the form
    if (e.detail.type === 'close') {
      window.dataLayer.push({
        'event': 'interaction_event',
        'event_name': 'pop_up_engagement',
        'event_action': 'close_form',
        'location': 'welcome'
      });
    }
    
    // user successfully completes the form
    if (e.detail.type === 'submit') {
      window.dataLayer.push({
        'event': 'interaction_event',
        'event_name': 'pop_up_engagement',
        'event_action': 'complete_form',
        'location': 'welcome'
      });
    }
  }
  
  
  
  if (e.detail.formId === 'WEMHZd') {
    // user clicks into a form field to begin filling out the form
    if (e.detail.type === 'open') {
      window.dataLayer.push({
        'event': 'interaction_event',
        'event_name': 'pop_up_engagement',
        'event_action': 'start_form',
        'location': 'teaser'
      });
    }
    
    // user closes the form
    if (e.detail.type === 'close') {
      window.dataLayer.push({
        'event': 'interaction_event',
        'event_name': 'pop_up_engagement',
        'event_action': 'close_form',
        'location': 'teaser'
      });
    }
    
    // user successfully completes the form
    if (e.detail.type === 'submit') {
      window.dataLayer.push({
        'event': 'interaction_event',
        'event_name': 'pop_up_engagement',
        'event_action': 'complete_form',
        'location': 'teaser'
      });
    }
  }
  
  
  
});




// user clicks to open filter menu
try {
  
  document
    .querySelector('.mobile-facets__open')
    .addEventListener('click', function(e){

      let event_data = {
        'event': 'interaction_event',
        'event_name': 'filter_engagement',
        'event_action': 'open_filter'
      }
      
      console.log("Recording event...", event_data)
      window.dataLayer.push(event_data);
      
    })
  
} catch(e) {}

// user selects a method for filtering a collection page
try {
  document
    .querySelectorAll('.mobile-facets__label')
    .forEach(el => {
      el.addEventListener('click', debounce(
        function(e){
          let filter_type = el.closest('ul.mobile-facets__list').previousElementSibling.textContent.trim()
          let click_text = el.querySelector('.mobile-facets__checkbox').value
          let event_data = {
            'event': 'interaction_event',
            'event_name': 'filter_engagement',
            'event_action': 'select_filter',
            'event_category': filter_type,
            'click_text': click_text,
            'event_label': click_text
          }
          
          console.log("Recording event...", event_data)
          window.dataLayer.push(event_data);
        },
        300
      ))
    })
  
} catch(e) {}



// user clicks hyperlink to plus size
try {
  
  document
    .querySelectorAll('.mobile-facets__plus-size-link')
    .forEach(el => {
      el.addEventListener('click', function(e){

        let link_url = e.target.getAttribute('href')
        window.dataLayer.push({
         'event': 'interaction_event',
         'event_name': 'filter_engagement',
         'event_action': 'select',
         'event_category': 'plus_size',
         'link_url': link_url,
         'event_label': 'plus_size'
        });
        
      })
    })
  
} catch(e) {}


// user clicks on product tile to view item from a carousel featured on the homepage
try {

  document
    .querySelectorAll('.slideshow .slideshow__text .button')
    .forEach(el => {
      el.addEventListener('click', function(e){

        let container = e.target.closest('.slideshow__text')
        let carousel_name = container.querySelector('.banner__heading').textContent.trim()
        let link_text = e.target.textContent.trim()
        let link_url = e.target.getAttribute('href')
        
        window.dataLayer.push({
          'event': 'interaction_event',
          'event_name': 'carousel_engagement',
          'event_action': 'link_click',
          'event_label': carousel_name,
          'event_category': carousel_name,
          'click_text': link_text,
          'link_url': link_url
         });

      })
    })
  
} catch(e) {}


// user clicks on product tile to view item from a carousel featured on the homepage
try {
  
  document
    .querySelectorAll('.multicolumn-list a[href*="blogs/"]')
    .forEach(el => {
      el.addEventListener('click', function(e){

        let link_text = e.target.textContent.trim().replace('ENTER', '').trim()
        let link_url = e.target.getAttribute('href')
        
        window.dataLayer.push({
          'event': 'interaction_event',
          'event_name': 'blog_engagement',
          'event_action': 'link_click_to_blog',
          'event_label': link_text,
          'click_text': link_text,
          'link_url': link_url
         });

      })
    })
  
} catch(e) {}



// user clicks on product tile to view item from a carousel featured on the homepage
try {
  
  document
    .querySelectorAll('#Slider-template--14887188136033__featured_collection a[href*="products/"]')
    .forEach(el => {
      el.addEventListener('click', function(e){

        let link_text = e.target.textContent.trim().replace('ENTER', '').trim()
        let link_url = e.target.getAttribute('href')

        window.dataLayer.push({
          'event': 'interaction_event',
          'event_name': 'upsell_engagement',
          'event_action': 'link_click',
          'event_label': link_text,
          'link_url': link_url,
          'click_text': link_text,
          'location': 'homepage'
         });

      })
    })
  
} catch(e) {}




// user clicks on product tile to view item from a carousel featured on the homepage
try {
  
  document.addEventListener('rebuy:cart.add', (event) => { 
    
    let is_upsell = event.detail?.item?.properties?._attribution === 'Rebuy Cart'
    if (! is_upsell) {
      return false;
    }
    
    window.dataLayer.push({
      'event': 'interaction_event',
      'event_name': 'upsell_engagement',
      'event_action': 'link_click',
      'event_label': event.detail?.item?.title,
      'click_text': 'Add',
      'location': 'cart'
    });

  });
      
} catch(e) {}





// target LP

try {

  if (location.href.includes('/pages/target')) {

    document
      .querySelectorAll('#MainContent .shopify-section:first-child .banner__box')
      .forEach(el => {
        el.addEventListener('click', function(e) {

          fbq('track', 'CompleteRegistration');

          /*
          let event_name = 'target_lp_banner_engagement'
          let click_text = "(OR AT TARGET.COM)"
          let link_url = ""
          let event_data = {
            'event': 'interaction_event',
            'event_name': event_name,
            'event_action': 'button_click',
            'event_category': "",
            'click_text': click_text,
            'link_url': link_url,
            'location': ''
          }
          
          console.log("Recording event...", event_data)
          window.dataLayer.push(event_data);
          */
        })
      })

    document
      .querySelectorAll('#MainContent .shopify-section:nth-child(3) a.button')
      .forEach(el => {
        el.addEventListener('click', function(e) {

          fbq('track', 'CompleteRegistration');

          /*
          let event_name = 'target_lp_banner_engagement'
          let click_text = "Shop at Target"
          let link_url = ""
          let event_data = {
            'event': 'interaction_event',
            'event_name': event_name,
            'event_action': 'button_click',
            'event_category': "",
            'click_text': click_text,
            'link_url': link_url,
            'location': ''
          }
          
          console.log("Recording event...", event_data)
          window.dataLayer.push(event_data);
          */

        })
      })

    setTimeout(function(){
      console.log("tracking storelocator...")
      
      document
        .querySelectorAll('#MainContent .shopify-section:nth-child(6) #submit-search')
        .forEach(el => {
          el.addEventListener('click', function(e) {

            fbq('track', 'FindLocation');
            
            /*
            let event_name = 'target_lp_map_engagement'
            let click_text = "Search"
            let link_url = ""
            let event_data = {
              'event': 'interaction_event',
              'event_name': event_name,
              'event_action': 'button_click',
              'event_category': "",
              'click_text': click_text,
              'link_url': link_url,
              'location': ''
            }
            
            console.log("Recording event...", event_data)
            window.dataLayer.push(event_data);
            */
            
          })
        })
    }, 3000)

    setTimeout(function(){
      console.log("tracking klaviyo...")
      
      document
        .querySelectorAll('#MainContent .klaviyo-form-Vg7WpZ button')
        .forEach(el => {
          el.addEventListener('click', function(e) {

            fbq('track', 'Subscribe');
            /*
            let event_name = 'target_lp_sign_up'
            let click_text = "Get notified"
            let link_url = ""
            let event_data = {
              'event': 'interaction_event',
              'event_name': event_name,
              'event_action': 'button_click',
              'event_category': "",
              'click_text': click_text,
              'link_url': link_url,
              'location': ''
            }
            
            console.log("Recording event...", event_data)
            window.dataLayer.push(event_data);
            */
          })
        })
    }, 3000)


    document
      .querySelectorAll('#MainContent .shopify-section:nth-child(9) .button')
      .forEach(el => {
        el.addEventListener('click', function(e) {

          fbq('track', 'AddToCart');
          /*
          let event_name = 'target_lp_bundle_atc'
          let click_text = "Add to bag"
          let link_url = ""
          let event_data = {
            'event': 'interaction_event',
            'event_name': event_name,
            'event_action': 'button_click',
            'event_category': "",
            'click_text': click_text,
            'link_url': link_url,
            'location': ''
          }
          
          console.log("Recording event...", event_data)
          window.dataLayer.push(event_data);
          */
                
        })
      })

    document
      .querySelectorAll('#MainContent .shopify-section:nth-child(9) .button + div > a')
      .forEach(el => {
        el.addEventListener('click', function(e) {

          fbq('track', 'AddToWishlist');
          /*
          let event_name = 'target_lp_bundle_details'
          let click_text = "Product details"
          let link_url = ""
          let event_data = {
            'event': 'interaction_event',
            'event_name': event_name,
            'event_action': 'button_click',
            'event_category': "",
            'click_text': click_text,
            'link_url': link_url,
            'location': ''
          }
          
          console.log("Recording event...", event_data)
          window.dataLayer.push(event_data);
          */
        })
      })
    
  }
} catch(e) {}




try {

  document
    .querySelectorAll('#target-cta')
    .forEach(el => {
      el.addEventListener('click', function(e) {

        fbq('track', 'CompleteRegistration');

        /*
        let event_name = 'target_lp_hero_engagement'
        let click_text = "Available at Target"
        let link_url = ""
        let event_data = {
          'event': 'interaction_event',
          'event_name': event_name,
          'event_action': 'button_click',
          'event_category': "",
          'click_text': click_text,
          'link_url': link_url,
          'location': ''
        }
        
        console.log("Recording event...", event_data)
        window.dataLayer.push(event_data);
        */
              
      })
    })
} catch(e){}